import axios from 'axios';
import { sha256 } from 'js-sha256';
import base64url from "base64url";
import config from '@/config'

const API_URL = config.API_URL

export default {
  state: {
    user_accounts_numbers: [],
    verification_mail_ansver: null,
    verification_tel_ansver: null
  },
  mutations: {
    userAccounts: (state, response) => state.user_accounts_numbers = response,
    userVerificationTelAnsverMutation: (state, response) => state.verification_tel_ansver = response,
    userVerificationMailAnsverMutation: (state, response) => state.verification_mail_ansver = response,
  },
  actions: {
    async userAccountsFetch(ctx){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.get(
        `${API_URL}/api/rest/receipt/kabinet_ls?secret_key=${key}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        const accounts = response.data.items
        localStorage.setItem('weltumTimeAuth', Date.now())
        ctx.commit('userAccounts', accounts)
      })
    },
    async verification(ctx, cod){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      await axios.post(
        `${API_URL}/api/rest/receipt/verification_of_confirmation`, 
        {
          "secret_key":key,
          "kod_verif": cod
        },
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {

        const verification = response.data.msg
        if(cod == 1){
          ctx.commit('userVerificationMailAnsverMutation', verification)
        } else if ( cod == 2) {
          ctx.commit('userVerificationTelAnsverMutation', verification)
        }
        
      })      
    }
  },
  getters:{
    userAccountsNumbers: s => s.user_accounts_numbers,
    userVerificationTelAnsver: s => s.verification_tel_ansver,
    userVerificationMailAnsver: s => s.verification_mail_ansver,
  },
}